import { render, staticRenderFns } from "./NoDataCard.vue?vue&type=template&id=29f5830a&scoped=true&"
import script from "./NoDataCard.vue?vue&type=script&lang=ts&"
export * from "./NoDataCard.vue?vue&type=script&lang=ts&"
import style0 from "./NoDataCard.vue?vue&type=style&index=0&id=29f5830a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f5830a",
  null
  
)

export default component.exports